import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeActivitiesByIdController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeActivitiesByIdController.php
* @route '/api/payment-mode/{payment_mode}/activities'
*/
const GetPaymentModeActivitiesByIdController = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentModeActivitiesByIdController.url(args, options),
    method: 'get',
})

GetPaymentModeActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/payment-mode/{payment_mode}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeActivitiesByIdController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeActivitiesByIdController.php
* @route '/api/payment-mode/{payment_mode}/activities'
*/
GetPaymentModeActivitiesByIdController.url = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { payment_mode: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { payment_mode: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            payment_mode: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        payment_mode: typeof args.payment_mode === 'object'
        ? args.payment_mode.id
        : args.payment_mode,
    }

    return GetPaymentModeActivitiesByIdController.definition.url
            .replace('{payment_mode}', parsedArgs.payment_mode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeActivitiesByIdController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeActivitiesByIdController.php
* @route '/api/payment-mode/{payment_mode}/activities'
*/
GetPaymentModeActivitiesByIdController.get = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentModeActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeActivitiesByIdController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeActivitiesByIdController.php
* @route '/api/payment-mode/{payment_mode}/activities'
*/
GetPaymentModeActivitiesByIdController.head = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPaymentModeActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetPaymentModeActivitiesByIdController